<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  props: {
    facilityId: {
      type: String,
      value: "",
    },
    createBy: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "",
      key: "id",
      url: {},
      items: [
        { label: "填写设备出库信息", type: "header" },
        {
          label: "选择核算科室",
          name: "checkDeskId",
          type: "cascader",
          dropList: [],
          filterable: true, 
          onChange: this.onChange,
          color: "#515a6e",
          rules: [
            {
              required: true,
              message: "核算科室不能为空",
              trigger: "blur",
              type: "array",
            },
          ],
        },
        {
          label: "选择科室",
          name: "deskId",
          value: "",
          type: "select",
          dropList: [],
          remoteMethod: this.deskChange,
          onChange: this.loadDeskData,
          rules: [
            {
              required: true,
              message: "科室不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        {
          label: "楼宇",
          name: "building",
          value: "",
          type: "select",
          dropList: [],
          onChange: this.getFloor,
          rules: [
            {
              required: true,
              message: "楼宇不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        {
          label: "楼层",
          name: "floor",
          value: "",
          type: "select",
          dropList: [],
          rules: [
            {
              required: true,
              message: "楼层不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        {
          label: "房间号",
          name: "room",
          value: "",
          type: "input",
          rules: [
            { required: true, message: "房间号不能为空", trigger: "blur" },
          ],
        },
        {
          label: "备注信息",
          name: "remark",
          value: "",
          type: "textarea",
        },
      ],
      forms: {
        checkDeskId: [],
        facilityId: this.facilityId,
        deskinfo: null,
        state: 2,
        createBy: this.createBy,
        deliveryBy: $utils.data.get("auth", "userName"),
      },
      checkDeskIds: "",
    };
  },
  created() {
    this.getCheckDeskList();
    this.loadLevelData();
    this.getBuilding();
  },
  watch: {
    'forms.checkDeskId': {
      immediate: true,
      handler(val) {
        if (Array.isArray(val) && val.length > 0) {
          this.checkDeskIds = Number(val[val.length - 1]);
        } else if (typeof val === 'string' && val) {
          if (val.indexOf(',') !== -1) {
            const arr = val.split(',');
            this.checkDeskIds = Number(arr[arr.length - 1]);
          } else {
            this.checkDeskIds = Number(val);
          }
        } else {
          this.checkDeskIds = '';
        }
      },
    },
  },
  methods: {
    onChange(e) {
      let arr;
      if (Array.isArray(e)) {
        arr = e.map(item => Number(item));
      } else if (e !== undefined && e !== null && e !== "") {
        const findPath = (list, targetValue, path = []) => {
          for (const item of list) {
            const currentPath = [...path, item.value];
            if (item.value === targetValue) {
              return currentPath;
            }
            if (item.children && item.children.length > 0) {
              const childPath = findPath(item.children, targetValue, currentPath);
              if (childPath) {
                return childPath;
              }
            }
          }
          return null;
        };
        const checkDeskItem = this.items.find(item => item.name === 'checkDeskId');
        if (checkDeskItem && checkDeskItem.dropList) {
          const fullPath = findPath(checkDeskItem.dropList, Number(e));
          if (fullPath) {
            arr = fullPath.map(item => Number(item));
          } else {
            arr = [Number(e)];
          }
        } else {
          arr = [Number(e)];
        }
      } else {
        arr = [];
      }
      this.forms.checkDeskId = arr;
      this.checkDeskIds = arr.length > 0 ? Number(arr[arr.length - 1]) : "";
      console.log('选中的数组:', arr, '提交的数字:', this.checkDeskIds);
    },
    async getCheckDeskList() {
      let d = {};
      let res = await $utils.api.load("admin/system/check/list", d, "get");
      if (res.code === 200) {
        let data = res.rows;
        let dropList = [];
        if (data && data.length > 0) {
          dropList = data.map((item) => ({
            value: item.id,
            label: item.checkDeskName,
            disabled: !item.children || item.children.length === 0,
            children: (item.children || []).map((child) => ({
              value: child.id,
              label: child.checkDeskName,
            })),
          }));
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name === "checkDeskId") {
            this.$set(this.items[index], "dropList", dropList);
          }
        }
      }
    },
    loadDeskData(deskId) {
      let that = this;
      if (deskId) {
        // 通过pk查询字典数据
        $utils.api.load(`/admin/system/desk/${deskId}`).then((res) => {
          if (res && res.data) {
            let workInfotemp = "";
            if (
              res.data.principal !== null &&
              res.data.principal !== undefined
            ) {
              workInfotemp = res.data.principal;
            }
            // console.log(666,workInfotemp)
            if (res.data.phone !== null && res.data.phone !== undefined) {
              workInfotemp = workInfotemp + "/" + res.data.phone;
            }
            // console.log(777,workInfotemp)
            if (res.data.address !== null && res.data.address !== undefined) {
              workInfotemp = workInfotemp + "/" + res.data.address;
            }
            that.forms.deskinfo = workInfotemp;
          }
        });
      } else {
        that.forms.deskinfo = "";
      }
    },

    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };
          $utils.api
            .load(`/admin/system/desk/selectList`, q, "get")
            .then((res) => {
              const list = res.rows.map((item) => {
                return {
                  value: item.deskId,
                  name: item.deskId,
                };
              });
              for (let index = 0; index < this.filters.length; index++) {
                const element = this.filters[index];
                if (element && element.name == "deskId") {
                  this.filters[index]["dropList"] = list;
                }
              }
            });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          let q = { ...this.forms };
          q.checkDeskId = this.checkDeskIds;
          this.sloading = true;
          $utils.api
            .load(`/admin/system/facility/change`, q, "PUT")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$emit("reset");
              }
              this.$Modal.remove();
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$emit("reset");
              this.$Modal.remove();
            });
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load(`/admin/system/desk/selectList`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "deskId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    async getBuilding() {
      let d = {};
      let res = await $utils.api.load("admin/system/building/list", d, "get");
      // console.log(res);
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.buildingName;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "building") {
            this.items[index]["dropList"] = dropList;
            // this.items[index]["dropList"] = (
            //   this.items[index]["dropList"] || []
            // ).concat(dropList);
          }
        }
      }
    },
    async getFloor(e) {
      let d = {
        buildingId: e,
      };
      let res = await $utils.api.load("admin/system/floor/list", d, "get");
      // console.log(res);
      if (res.code == 200) {
        // this.floorList = res.rows
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.floorName;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "floor") {
            this.items[index]["dropList"] = dropList;
            // this.items[index]["dropList"] = (
            //   this.items[index]["dropList"] || []
            // ).concat(dropList);
          }
        }
      }
    },
    // loadLevelData() {
    //             let q = {}
    //             $utils.api.load('consumablesClassDropList', q).then((res) => {
    //             if(res && res.data){
    //                 let ll = res.data
    //                 let dropList = []
    //                 for (let index = 0; index < ll.length; index++) {
    //                     const element = ll[index];
    //                     let xx = {}
    //                     xx.value = element.id
    //                     xx.name = element.name
    //                     dropList.push(xx)
    //                 }
    //                 for (let index = 0; index < this.items.length; index++) {
    //                     const element = this.items[index];
    //                     if(element && element.name == 'id') {
    //                         this.items[index]['dropList'] = dropList
    //                     }
    //                 }
    //             }
    //         })
    //     },
  },
};
</script>
